module.exports = __webpack_public_path__ + "img/logo-pict-black.ca550039.svg";